
import {getKlines, subscribeKline, unsubscribeKline, checkInterval } from './helpers'

const configurationData = {
	supports_marks: false,
	supports_timescale_marks: false,
	supports_time: true,
	supported_resolutions: [
		'30', '60', '240', '1D', '1W'
	]
};

export default {
	// get a configuration of your datafeed (e.g. supported resolutions, exchanges and so on)
	onReady: (callback) => {
		console.log('[onReady]: Method call');
		setTimeout(() => callback(configurationData)) // callback must be called asynchronously.
	},

	 // NO need if not using search
	searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {
		console.log('[searchSymbols]: Method call');
		console.log(exchange)
	},

	// retrieve information about a specific symbol (exchange, price scale, full symbol etc.)
	resolveSymbol: (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
		console.log('[resolveSymbol]: Method call', symbolName);

		const comps = symbolName.split(':')
		symbolName = (comps.length > 1 ? comps[1] : symbolName).toUpperCase()



		const symbolInfo = (symbol) => (
			{
			name: symbol,
			description: symbol,
			ticker: symbol.symbol,
			// exchange: 'Binance',
			// listed_exchange: 'Binance',
			type: 'crypto',
			session: '24x7',
			minmov: 1,
			pricescale: 100,
			timezone: 'UTC',
			has_intraday: true,
			has_daily: true,
		})

		// Get symbols
		const symbol = [ 'BTCUSDT', 'ETHUSDT', 'XRPUSDT', 'BNBUSDT', 'ADAUSDT', 'DOTUSDT'].find(i => i == symbolName)
		return symbol ? onSymbolResolvedCallback(symbolInfo(symbol)) : onResolveErrorCallback('[resolveSymbol]: symbol not found')

	},
	// get historical data for the symbol
	// https://github.com/tradingview/charting_library/wiki/JS-Api#getbarssymbolinfo-resolution-periodparams-onhistorycallback-onerrorcallback
	getBars: async (symbolInfo, interval, periodParams, onHistoryCallback, onErrorCallback) => {
		console.log("=============get data=================")
		console.log(symbolInfo)
		console.log(interval)
		console.log(periodParams)
		console.log('[getBars] Method call', symbolInfo, interval)
		if (!checkInterval(interval)) {
			return onErrorCallback('[getBars] Invalid interval')
		}
		var from;
		if(periodParams.firstDataRequest){
			from = periodParams.from
		}else{
			from = periodParams.from
		}
		const klines = await getKlines({ symbol: symbolInfo.name, interval})
		console.log(klines)
		if (klines.length >= periodParams.countBack) {
			onHistoryCallback(klines, {noData: false})
		} else {
			onHistoryCallback(klines, {noData: true})
		}

		// if (klines.length > 0) {
		// 	return onHistoryCallback(klines)
		// }

		onErrorCallback('Klines data error')

	},
	// subscription to real-time updates
	subscribeBars: (symbolInfo, interval, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback) => {
		console.log('[subscribeBars]:', subscribeUID);
        window.interval = setInterval(function () {
            subscribeKline({ symbol: symbolInfo.name, interval, uniqueID: subscribeUID, }, cb => onRealtimeCallback(cb))
        }, 1000 * 3) // 60s update interval
	},
	unsubscribeBars: (subscriberUID) => {
		console.log('[unsubscribeBars]', subscriberUID);
		clearInterval(window.interval)
        console.log('[unsubscribeBars]: cleared')
	},
	// getServerTime: (callback) => {
	// 	getExchangeServerTime().then(time => {
	// 		callback(Math.floor(time / 1000))
	// 	}).catch(err => {
	// 		console.error(err)
	// 	})
	// }
};



// WEBPACK FOOTER //
// ./src/components/api/index.js